<template>
    <div id="history" class="pd20">
        <h5>Upload bảng lương lên</h5>
        <div class="listing">
            <div class="w50">
                <div class="custom-file">
                    <input type="file" class="custom-file-input" name="fileupload" id="fileupload" ref="fileupload" @change="handleFileUpload()" required>
                    <label class="custom-file-label" for="fileupload">Chọn file bảng lương...</label>
                </div>
                <div class="pdtb10">
                    <span class="btn btn-primary">Bắt đầu upload</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import {callApi, generate_page} from '@/helper/function'
import {mapGetters} from 'vuex'
import Axios from 'axios'
export default {
    name : 'chat',
    data () {
        return {
            
        }
    },
    computed: {
        ...mapGetters(['getUser', 'get_user_permission'])
    },
    created() {
        
    },
    methods: {
        /** Handle file upload */
        handleFileUpload : function(){            
            this.fileupload = this.$refs.fileupload.files[0]
            let formdata = new FormData()
            formdata.append('file', this.fileupload)
            axios.post(
                process.env.VUE_APP_UPLOAD, 
                formdata,
                {
                    headers:{
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then((res)=>{
                let data = res.data
                let code = data.code
                let err  = data.error
                this.$refs.fileupload.value=null
                if(code == 200){
                    this.$store.commit('set_alert_msg_success', 'Tải file lên thành công')
                }else{
                    let msg_err = data.error
                    this.$store.commit('set_alert_msg_error', msg_err)
                }
            }).catch((err)=>{
                this.$store.commit('set_alert_msg_error', err)
            })
        },

    },
}
</script>
<style>
#history{
    height: 100%;
    overflow: auto;
}
.filter_group{
    border-radius: 3px;
    padding: 10px 5px 8px 5px;
    margin-right: 10px;
    border: 1px solid #616161;
}
.filter_label{
    position: absolute;
    top: -8px;
    left: 5px;
    background-color: #fff;
    font-size: 11px;
    padding: 0 5px;
    border-radius: 10px;
}
.success{
    background-color: #A6EAB5;
}
</style>
